import {css} from 'lit';
export const styles = css`:host {
  display: block;
  background-color: var(--contrast-light);
  font-size: 14px;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 42px;
}

@media screen and (min-width: 500px) {
  .item {
    flex-wrap: wrap;
  }
}

ef-avatar-list {
  --avatar-size: 40px;
  --avatar-border: 2px solid var(--contrast-light);
  --label-bg: var(--secondary-500);
  --label-text: var(--contrast-light);
  --label-font-size: 0.857em;
  --label-font-weight: 600;
  --label-border-radius: 50px;
  --label-padding: 2px 8px;
  --width: 100%;

  margin-top: 8px;
  order: 4;
}

.info {
  margin-right: 16px;
}

.card-date-item-check {
  margin-left: auto;
}

@media screen and (min-width: 500px) {
  ef-avatar-list {
    --width: auto;

    margin-top: 0;
    order: unset;
    flex: 1 1 auto;
  }

  .info {
    margin-right: 16px;
  }
}

.datetime-widget,
.attendance {
  width: 100px;
  display: flex;
  position: relative;
  flex: 1 1 auto;
  margin-right: 16px;
  padding-right: 16px;
}

@media screen and (min-width: 500px) {
  .datetime-widget {
    display: block;
    padding-right: 16px;
  }
}

.time-widget {
  display: inline-flex;
  justify-content: center;
  position: relative;
  margin-right: 8px;
  padding-right: 8px;
}

@media screen and (min-width: 500px) {
  .time-widget {
    display: flex;
    margin-right: 0;
    padding-right: 0;
  }
}

.time-widget::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 80%;
  background-color: var(--color1);
  transform: translateY(-50%);
}

@media screen and (min-width: 500px) {
  .time-widget::before {
    display: none;
  }
}

.date-widget {
  display: inline-flex;
}

.date-widget-month {
  margin-left: 4px;
  margin-right: 4px;
  color: var(--color1);
}

@media screen and (min-width: 500px) {
  .datetime-widget,
  .attendance {
    flex: none;
    text-align: center;
  }
}

.attendance > * {
  font-size: 0.857em;
  text-transform: uppercase;
  color: var(--text-primary);
}

@media screen and (min-width: 500px) {
  .attendance::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 1px;
    height: 30px;
    background: var(--border);
    z-index: 1;
    transform: translateY(-50%);
  }
}

.item-check {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 500px) {
  .datetime-widget::after,
  .attendance::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 1px;
    height: 30px;
    background: var(--gray-300);
    z-index: 1;
    transform: translateY(-50%);
  }
}

.custom-input[type='checkbox'],
.custom-input[type='radio'] {
  position: absolute;
  left: -9999px;
}

.custom-input[type='checkbox'] + label,
.custom-input[type='radio'] + label {
  position: relative;
  min-height: 20px;
  margin: 0;
  padding-right: 24px;
  cursor: pointer;
}

.custom-input[type='checkbox'] + label::before,
.custom-input[type='checkbox'] + label::after,
.custom-input[type='radio'] + label::before,
.custom-input[type='radio'] + label::after {
  position: absolute;
  top: 0;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.custom-input[type='checkbox'] + label::before,
.custom-input[type='radio'] + label::before {
  content: '';
  border: 2px solid var(--primary-500);
}

.custom-input[type='radio'] + label::before {
  border-radius: 50%;
}

.custom-input[type='checkbox']:disabled + label::before,
.custom-input[type='checkbox']:disabled + label::after,
.custom-input[type='radio']:disabled + label::before,
.custom-input[type='radio']:disabled + label::after {
  border-color: var(--gray-500);
  color: var(--gray-500);
}

.custom-input[type='checkbox'] + label::after,
.custom-input[type='radio'] + label::after {
  content: '\\e90a';
  font-family: var(--icon);
  color: var(--primary-500);
  text-align: center;
  font-size: 0.7143em;
  opacity: 0;
}

.custom-input[type='checkbox']:checked + label::after,
.custom-input[type='radio']:checked + label::after {
  opacity: 1;
}
`;
export default styles;
